/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProviderDirectoryContactType } from './ProviderDirectoryContactType';
import {
    ProviderDirectoryContactTypeFromJSON,
    ProviderDirectoryContactTypeFromJSONTyped,
    ProviderDirectoryContactTypeToJSON,
} from './ProviderDirectoryContactType';

/**
 * 
 * @export
 * @interface UpdateDirectoryContactRequest
 */
export interface UpdateDirectoryContactRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateDirectoryContactRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDirectoryContactRequest
     */
    position?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDirectoryContactRequest
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDirectoryContactRequest
     */
    phone?: string | null;
    /**
     * 
     * @type {ProviderDirectoryContactType}
     * @memberof UpdateDirectoryContactRequest
     */
    contact_type?: ProviderDirectoryContactType;
}

/**
 * Check if a given object implements the UpdateDirectoryContactRequest interface.
 */
export function instanceOfUpdateDirectoryContactRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateDirectoryContactRequestFromJSON(json: any): UpdateDirectoryContactRequest {
    return UpdateDirectoryContactRequestFromJSONTyped(json, false);
}

export function UpdateDirectoryContactRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDirectoryContactRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'position': !exists(json, 'position') ? undefined : json['position'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'contact_type': !exists(json, 'contact_type') ? undefined : ProviderDirectoryContactTypeFromJSON(json['contact_type']),
    };
}

export function UpdateDirectoryContactRequestToJSON(value?: UpdateDirectoryContactRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'position': value.position,
        'email': value.email,
        'phone': value.phone,
        'contact_type': ProviderDirectoryContactTypeToJSON(value.contact_type),
    };
}

